import debug from 'debug';

export const pbLog = (name: string) => debug(`pb:${name}`);
